import { Box, Button, Paper, TextField } from "@mui/material";
import { ReactNode } from "react";
import { FiSearch, FiX } from "react-icons/fi";

interface TableFiltersProps {
  search: string;
  onSearchChange: (val: string) => void;
  onClear?: () => void;
  hasActiveFilters?: boolean;
  searchPlaceholder?: string;
  children?: ReactNode;
}

export default function TableFilters({
  search,
  onSearchChange,
  onClear,
  hasActiveFilters = false,
  searchPlaceholder = "Buscar...",
  children,
}: TableFiltersProps) {
  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        flexWrap: "wrap",
        gap: 2,
        mb: 3,
        width: "100%",
        alignItems: { xs: "stretch", sm: "center" },
        p: 2,
      }}
    >
      {/* Campo de búsqueda */}
      <Box sx={{ flex: { xs: "1 1 100%", sm: "1 1 100%", lg: "2 1 200px" }, minWidth: 0 }}>
        <TextField
          fullWidth
          size="small"
          placeholder={searchPlaceholder}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          slotProps={{
            input: {
              startAdornment: <FiSearch style={{ marginRight: 8, color: "gray", flexShrink: 0 }} />,
            },
          }}
        />
      </Box>

      {/* Filtros adicionales (children)*/}
      {children && (
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            flexWrap: "wrap",
            gap: 2,
            flex: { xs: "1 1 100%", sm: "1 1 auto", lg: "3 1 auto" },
            minWidth: 0,
            "& > *": { 
              flex: { xs: "1 1 100%", sm: "1 1 0px" }, 
              width: { xs: "100%", sm: "auto" } 
            },
          }}
        >
          {children}
        </Box>
      )}

      {/* Botón limpiar — habilitado solo cuando hay filtros activos */}
      
        <Button
          size="small"
          variant="outlined"
          onClick={onClear}
          startIcon={<FiX />}
          disabled={!(hasActiveFilters && onClear)}
          sx={{
            flex: { xs: "1 1 100%", sm: "0 0 auto" },
            whiteSpace: "nowrap",
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "8px",
          }}
        >
          Limpiar
        </Button>
    </Paper>
  );
}
